import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { NoRowsOverlayContainer, NoRowsText } from './GeneratikTable.styles';

export interface GeneratikTableNoRowsOverlayProps extends HTMLAttributes<HTMLDivElement> {
  message?: string;
}

const GeneratikTableNoRowsOverlay = ({ message, ...rest }: GeneratikTableNoRowsOverlayProps) => {
  const { t } = useTranslation();

  return (
    <NoRowsOverlayContainer {...rest} data-testid="table-empty-state">
      <NoRowsText variant="body1">{message || t('No data available')}</NoRowsText>
    </NoRowsOverlayContainer>
  );
};

export default GeneratikTableNoRowsOverlay;
